module.exports = __webpack_public_path__ + "img/blog-default.76f17ae4.png";